import { render, staticRenderFns } from "./ReferralGiftDropdown.vue?vue&type=template&id=1dd73082&scoped=true"
import script from "./ReferralGiftDropdown.vue?vue&type=script&lang=ts"
export * from "./ReferralGiftDropdown.vue?vue&type=script&lang=ts"
import style0 from "./ReferralGiftDropdown.vue?vue&type=style&index=0&id=1dd73082&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd73082",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd73082')) {
      api.createRecord('1dd73082', component.options)
    } else {
      api.reload('1dd73082', component.options)
    }
    module.hot.accept("./ReferralGiftDropdown.vue?vue&type=template&id=1dd73082&scoped=true", function () {
      api.rerender('1dd73082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ReferralGiftDropdown.vue"
export default component.exports